import { Swiper, SwiperRef } from "antd-mobile";
import IOSAndHD from "./IOSAndHD";
import MoreProductsComponent from "./MoreProductsComponent";
import TVComponent from "./TVComponent";
import WindowMac from "./WindowMac";
import React from "react";
import { showDownloadTabpage } from "@/report";

interface IClientAppProps {}
const ClientApp: React.FC<IClientAppProps> = () => {
  const ref = React.useRef<SwiperRef>(null);
  const next = () => {
    ref.current?.swipeNext();
  };
  const NavList = [
    {
      reportTab: "0",
      navTag: ["pc", "mac"],
      component: <WindowMac next={next} />,
    },
    {
      reportTab: "1",
      navTag: ["android", "iphone", "ipad", "pad"],
      component: <IOSAndHD next={next} />,
    },
    {
      reportTab: "2",
      navTag: ["tv"],
      component: <TVComponent next={next} />,
    },
    {
      reportTab: "3",
      navTag: ["pc_express"],
      component: <MoreProductsComponent />,
    },
  ];
  React.useEffect(() => {
    const nav = window.location.hash.replace("#", "");
    const navItem = NavList.findIndex(item => item.navTag.includes(nav));
    if (navItem !== -1) {
      ref.current?.swipeTo(navItem);
      showDownloadTabpage({
        tab: NavList[navItem].reportTab,
      });
    }
  }, []);

  return (
    <div className="client-app-wrap relative flex-1 overflow-hidden">
      <Swiper
        direction="vertical"
        className="!h-full"
        ref={ref}
        onIndexChange={index => {
          const navTag = NavList[index].navTag[0];
          showDownloadTabpage({
            tab: NavList[index].reportTab,
          });
          window.location.hash = `#${navTag}`;
        }}
      >
        {NavList.map((item, index) => (
          <Swiper.Item className="h-full" key={index}>
            {item.component}
          </Swiper.Item>
        ))}
      </Swiper>
    </div>
  );
};

export default ClientApp;
